module.exports = __webpack_public_path__ + "static/media/uniaoEuropeia.586beec2.webp";